import React, { useEffect, useRef, useState } from 'react';
import { useCariTarihBildirim } from '../../hooks/useCariTarihBildirim';

function tarihYaz(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString('tr-TR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
}

export default function CariTarihBildirimBadge() {
  const { sayi = 0, list, refresh } = useCariTarihBildirim();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  useEffect(() => {
    const close = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);
  return (
    <div ref={rootRef} style={{ position: 'relative' }}>
      <button
        type="button"
        title="Önümüzdeki 7 gündeki randevu ve ileri tarih hatırlatmaları"
        onClick={() => { setOpen((value) => !value); refresh(); }}
        style={{ border: 0, background: 'transparent', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 12, maxWidth: '100%', padding: 0, color: 'inherit' }}
      >
        <span style={{ position: 'relative', fontSize: 20, lineHeight: 1, flex: '0 0 auto' }}>
          <span aria-hidden>🔔</span>
          <span style={{ position: 'absolute', right: -7, top: -5, background: '#dc3545', color: '#fff', borderRadius: 10, minWidth: 18, padding: '1px 5px', fontSize: 11, fontWeight: 700 }}>{sayi}</span>
        </span>
        <span style={{ fontSize: 12, fontWeight: 600, lineHeight: 1.15, whiteSpace: 'normal', overflowWrap: 'anywhere' }}>Tarih</span>
      </button>
      {open && (
        <div style={{ position: 'absolute', right: 0, top: 34, zIndex: 3000, width: 380, maxHeight: 420, overflowY: 'auto', background: '#fff', border: '1px solid #cbd5e1', borderRadius: 8, boxShadow: '0 12px 30px rgba(15,23,42,.22)' }}>
          <div style={{ padding: '10px 12px', fontWeight: 700, borderBottom: '1px solid #e2e8f0' }}>Randevu / İleri Tarih</div>
          {list.map((row) => (
            <div key={`${row.CD_REF}-${row.TIP}`} style={{ padding: '9px 12px', borderBottom: '1px solid #f1f5f9' }}>
              <div style={{ fontWeight: 700 }}>{row.CAR_ADSOY || `Cari #${row.CAR_REF}`}</div>
              <div style={{ fontSize: 12, color: row.TIP === 'RANDEVU' ? '#b91c1c' : '#1d4ed8' }}>
                {row.TIP === 'RANDEVU' ? 'Randevu' : 'İleri tarih'} · {tarihYaz(row.TARIH)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
